import {
  ChangeEvent,
  forwardRef,
  ReactNode,
  TextareaHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputSize?: 'small' | 'medium' | 'large' | 'extra_large';
  theme?: 'grey';
  isInvalid?: boolean;
  startDecorator?: ReactNode;
  startDecoratorClassName?: string;
  endDecorator?: ReactNode;
  endDecoratorClassName?: string;
  inputClassName?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const {
      inputSize = 'medium',
      theme,
      className,
      value,
      isInvalid = false,
      startDecorator,
      startDecoratorClassName,
      endDecorator,
      endDecoratorClassName,
      inputClassName,
      onChange,
      rows = 6,
      ...rest
    } = props

    const [ isFilled, setIsFilled ] = useState(false)
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useEffect(() => {
      setIsFilled(!!value)
    }, [ value ])

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      setIsFilled(!!e.target.value)
      if (onChange) onChange(e)
    }

    return (
      <div
        className={cn(styles.root, styles[inputSize], className, {
          [styles._error]: isInvalid,
          [styles._filled]: isFilled,
          [styles[`_${theme}`]]: theme,
        })}
      >
        {startDecorator && (
          <div
            className={cn(
              styles['root__decorator-start'],
              startDecoratorClassName,
            )}
          >
            {startDecorator}
          </div>
        )}

        {endDecorator && (
          <div
            className={cn(styles['root__decorator-end'], endDecoratorClassName)}
          >
            {endDecorator}
          </div>
        )}

        <textarea
          ref={ref ?? textareaRef}
          className={cn('reset-input', styles.input, inputClassName)}
          value={value}
          onChange={handleChange}
          rows={rows}
          {...rest}
        />
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'

export default Textarea
